export const actionTypes: any = {
  GET_FIXED_DEPOSIT_LEADS_START: 'GET_FIXED_DEPOSIT_LEADS_START',
  GET_FIXED_DEPOSIT_LEADS_SUCCESS: 'GET_FIXED_DEPOSIT_LEADS_SUCCESS',
  GET_FIXED_DEPOSIT_LEADS_FINISH: 'GET_FIXED_DEPOSIT_LEADS_FINISH',
}
